import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { PatientVerificationQuestionnaireItem } from './questionnaire'

// Patient Verification subsection questionnaire answer type mapping
export const PATIENT_VERIFICATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [PatientVerificationQuestionnaireItem.PATIENT_VERIFICATION_LEGAL_NAME]:
    QuestionnaireAnswerType.STRING,
  [PatientVerificationQuestionnaireItem.PATIENT_VERIFICATION_PREFERRED_NAME]:
    QuestionnaireAnswerType.STRING,
  [PatientVerificationQuestionnaireItem.PATIENT_VERIFICATION_ADDRESS]:
    QuestionnaireAnswerType.STRING,
  [PatientVerificationQuestionnaireItem.PATIENT_VERIFICATION_DOB]: QuestionnaireAnswerType.DATE,
  [PatientVerificationQuestionnaireItem.PATIENT_VERIFICATION_GENDER]:
    QuestionnaireAnswerType.CODING,
  [PatientVerificationQuestionnaireItem.PATIENT_VERIFICATION_MEDICAID_ID]:
    QuestionnaireAnswerType.STRING
}
